import { render, staticRenderFns } from "./ZDSpecOptionButton.vue?vue&type=template&id=3f6bcefe&"
import script from "./ZDSpecOptionButton.vue?vue&type=script&lang=js&"
export * from "./ZDSpecOptionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports